// extracted by mini-css-extract-plugin
export default {"root":"ZRVftU7qDZIWfNQj2UefQg==","input":"YkazCoQqS1YCC+0TRWmtKQ==","text":"sR7GDmzvVTsWwIa7cLMKsA=="};